<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import defaultV2Client from '@/plugins/axios/defaultV2Client'

export default {
  data() {
    return {}
  },
  async created() {
    const {
      data: { data },
    } = await defaultV2Client.get('/payments?page=1&limit=1&status=failed')
    if (data.length > 0) {
      await this.$swal.basic.alert2({
        html: `
          <p style="font-size: 16px !important; font-weight: 700 !important; color: #6D6AFF; line-height: 2;">
            송금이 완료되지 않은 신청건이 있어요.
          </p>
          <p>운영팀에서 빠르게 확인하고 안내해드릴게요.</p>
        `,
      })
    }
  },
  computed: {},
  methods: {},
  render() {
    return <div></div>
  },
}
</script>
